/*
* Controls, render em and they do stuff
*
*/

(function (SG, window, undefined) {
  SG.registerModule('controls');
  SG.bind('initialize:after', function(graph) {
    graph.bindTo(graph, 'reflow', graph.repositionPlotToggles);
    graph.bindTo(graph, 'data:change', graph.drawPlotToggles);
    graph.bindTo(graph, 'partition:change', graph.drawPartitionControl);
    graph.bindTo(graph, 'render:after', graph.drawPartitionControl);
  });

  var ControlsBar, SaveSelection, ChangeColor;

  _.extend(SG.prototype, {
    // draw the little checkboxes that you can click on to
    // disable/enable metrics
    drawPlotToggles: function() {
      if(!this.controlsBar && this.get('displayControls')) {
        this.controlsBar = new ControlsBar({graph: this});
      }
      return;

      // the below code supported metrics variants (moving averages for watts)
      //
      //if(this.$toggles) this.$toggles.remove();
      //if(this.$variants) {
      //  this.$variants.remove();
      //  delete this.$variants;
      //}
      //// we'll need to figure out what metrics are actually available
      //var metrics = this.metricsY(),
      //  metricsEnabled = this.metricsEnabled(),
      //  readOnly = false;
      //
      //this.$toggles = $('<div></div>')
      //  .addClass(this.uniqueClass)
      //  .addClass('sg-elem')
      //  .addClass('sample-graph-toggles')
      //  .css({zIndex: this.zIndex()});
      //for(var i=0; i < metrics.length; i++) {
      //  var metric = metrics[i];
      //  var metricKey = metric.key();
      //  $toggle = $('<label><input type="checkbox" value="'+metricKey+'">' + T.t('sample_graph.' + metricKey) + '</label>')
      //    .addClass(metricKey);
      //  return;
      //  // check to see if there are computed versions of this metric
      //  // to render
      //  if(metric.computed().length > 0) {
      //    var computed = metric.computed();
      //    // only supporting one right now
      //    this.$variants = $('<ul></ul>')
      //      .addClass(this.uniqueClass)
      //      .addClass('sg-elem')
      //      .addClass('sg-variants')
      //      .addClass('button2-vertical-group')
      //      .data('metric', metricKey)
      //      .css({zIndex: this.zIndex() + 1000}) // need it above labels!
      //      .hide();
      //    this.$variantsToggle = $('<a href="javascript:;">+ options</a>')
      //      .addClass(this.uniqueClass)
      //      .addClass('sg-elem')
      //      .addClass('sg-variants-toggle')
      //      .data('metric', metricKey)
      //      .css({zIndex: this.zIndex()})
      //      .hide();
      //
      //    // first add the original metric
      //    var $variant = $('<li><a href="javascript:;">As recorded</a></li>')
      //      .addClass('selected')
      //      .data('metric', metric.key())
      //      .appendTo(this.$variants);
      //    for(var j=0; j < computed.length; j++) {
      //      $variant = $('<li><a href="javascript:;">' + computed[j].description() + '</a></li>')
      //        .data('metric', computed[j].key())
      //        .appendTo(this.$variants);
      //    }
      //    $variant.addClass('last');
      //    var self = this;
      //    // handle click to swap in a metric variant
      //    this.$variants.delegate('a', 'click', function() {
      //      var metricKey = $(this).closest('li').data('metric'),
      //        baseMetricKey = $(this).closest('ul').data('metric');
      //      self.$toggles.find('.' + baseMetricKey + ' input').val(metricKey);
      //      // update the ui for selected
      //      $(this).closest('ul').find('.selected').removeClass('selected');
      //      $(this).closest('li').addClass('selected');
      //      self.refreshMetricsEnabled();
      //    });
      //    this.$variantsToggle.click(function() {
      //      self.$variants.toggle();
      //      self.repositionPlotToggles();
      //    });
      //  }

      //  if(_.include(metricsEnabled, metricKey)) {
      //    $toggle.find('input').attr('checked', 'checked');
      //    if(metricsEnabled.length == 1)
      //      $toggle.find('input').attr('disabled', true);
      //  }

      //  $toggle.appendTo(this.$toggles);
      //}
      //if(this.$variants) {
      //  this.$variants.prependTo('body');
      //  this.$variantsToggle.prependTo('body');
      //}
      //this.$toggles.prependTo('body');
      //this.repositionPlotToggles();
      //var self = this;
      //this.$toggles.delegate('input', 'change', function() {
      //  // sorry this is hardcoded for now, still not sure how i want
      //  // this interface to look / work anyway
      //  if($(this).closest('label').hasClass('watts') && self.$variants) {
      //    if($(this).is(':checked'))
      //      self.$variantsToggle.show();
      //    else {
      //      self.$variantsToggle.hide();
      //      self.$variants.hide();
      //    }
      //  }
      //  self.refreshMetricsEnabled();
      //});
      //if(self.$variants && metrics.length == 1)
      //  self.$variantsToggle.show();
    },

    drawPartitionControl: function(partition) {
      if(!partition) partition = this.partition();
      if(this._partitionSeparators) {
        _.each(this._partitionSeparators, function(el) { el.remove(); });
      }
      if(!partition) {
        delete this._partitionSeparators;
        return;
      }

      var slices = partition.slices(),
          offset = this.$canvas.offset(),
          plotMargin = this.plotMargin(),
          xAxisType = this.xAxisType();

      var separators = this._partitionSeparators = [];

      for(var i=0; i < slices.length-1; i++) {
        var slice = slices[i],
            left = this.plotToPixel(slice.lastPoint()[xAxisType]) + offset.left - 5,
            top = offset.top + plotMargin.top,
            $separator = $('<div><div class="middle"></div></div>')
              .addClass(this.uniqueClass)
              .addClass('sg-elem')
              .addClass('sg-partition-separator')
              .css({zIndex: this.zIndex(), position: 'absolute'})
              .offset({top: top, left: left})
              .height(this.plotHeight).find('.middle').height(this.plotHeight).end()
              .prependTo(this.$body);
        separators.push($separator);
      }
    },

    standardBoundsTestFn: function($el, buffer) {
      return function(x,y) {
        var offset = $el.offset(), width = $el.width(), height = $el.height();
        if(buffer) {
          offset.left -= buffer;
          width += buffer*2;
        }
        return x > offset.left && x < (offset.left + width) && y > offset.top && y < (offset.top + height);
      };
    },

    inBoundsOfControl: function(x, y) {
      if (!this.activeControlsBoundsTests)
        return false;
      var node = this.activeControlsBoundsTests,
          tail = node.tail;
      while((node = node.next) !== tail) {
        if(node.fn.call(this, x, y)) return true;
      }
      return false;
    },

    addControlBoundsTest: function(fn) {
      var list = this.activeControlsBoundsTests || (this.activeControlsBoundsTests = {}),
          tail = list.tail || (list.tail = list.next = {});
      tail.fn = fn;
      list.tail = tail.next = {};
    },

    removeControlBoundsTest: function(fn) {
      var node, prev;
      if(node = prev = this.activeControlsBoundsTests) { // eslint-disable-line no-cond-assign
        while((node = node.next) && node.next) {
          if(node.fn === fn) {
            prev.next = node.next;
            break;
          }
          prev = node;
        }
      }
    },

    repositionPlotToggles: function() {
      if(this.controlsBar)
        this.controlsBar.reposition();
    }
  });

  ControlsBar = Backbone.View.extend({
    className: 'sg-bar',
    tmplId: 'sg-tmpl-control-bar',
    metricsTmplId: 'sg-tmpl-control-bar-metrics',
    initialize: function() {
      _.bindAll(this, 'onSegmentSelect', 'onSegmentDeselect', 'renderMetricsToggles', 'updateDisplayOfIncludeInMetrics', 'referencePoint');

      this.graph = this.options.graph;
      this.render();
      this.$el.addClass(this.graph.uniqueClass);
      this.$el.prependTo(this.graph.$canvas.parent());

      // add boudns test for the dropdowns (only applies when they are open)
      _.each(this.$('.dropdown-menu,.menu-container'), function(el) {
        this.graph.addControlBoundsTest(this.graph.standardBoundsTestFn($(el)));
      }, this);

      this.graph.bindTo(this.graph, 'segmentselector:load', this.onSegmentSelect);
      this.graph.bindTo(this.graph, 'segmentselector:unload', this.onSegmentDeselect);
      this.graph.bindTo(this.graph, 'data:change', this.renderMetricsToggles);
      this.graph.bindTo(this.graph, 'dataslice:select', this.updateDisplayOfIncludeInMetrics);
    },
    updateDisplayOfIncludeInMetrics: function(dataSlice) {
      this.$el.find('.sg-controls-unexclude-from-metrics')[
        dataSlice.points().find(pt => pt.excludeFromMetrics) ? 'show' : 'hide'
      ]()
    },
    render: function() {
      this.$el.html(SG.template(this.tmplId, {
          graph: this.graph
      }));
      this.renderMetricsToggles();
      return this;
    },
    renderMetricsToggles: function() {
      var metrics = _.map(this.graph.metricsY(), function(metric) { return metric.key(); });
      if(metrics.length === 0) {
        // this can still happen if we 1) import a route w/o st and then 2) clear map
        if (Routes.activeMap.activeRoute.showSurface) {
          metrics = ['ele', 'surfaces', 'grade'];
        } else {
          metrics = ['ele', 'grade'];
        }
      } else if (metrics.indexOf('surfaces') > 0 && !Routes.activeMap.activeRoute.showSurface) {
        metrics.remove(metrics.indexOf('surfaces'), 0);
      } else if (_.isEqual(metrics, ['surfaces'])) {
        // we hit this on first load
        metrics.unshift('ele');
      }
      this.$('.sg-controls-metrics').html(SG.template(this.metricsTmplId, {
        metrics: metrics
      }));
      var metricsEnabled = this.graph.metricsEnabled();
      if(metricsEnabled.length === 0) {
        if (Routes.activeMap.activeRoute.showSurface) {
          metricsEnabled = ['ele', 'surfaces'];
        } else {
          metricsEnabled = ['ele'];
        }
      }

      _.each(metricsEnabled, function(metricKey) {
        this.$('.sg-controls-metrics a[data-metric="'+metricKey+'"]').closest('li').addClass('active');
      }, this);
    },
    events: {
      // available when zoomed in
      'click .sg-controls-re-center': 'reCenter',
      'click .sg-controls-deselect': 'unload',

      // available always
      'click .sg-controls-zoom-out': 'zoomOut',
      'click .sg-controls-metrics a': 'toggleMetric',
      'click .sg-controls-minimize': 'minimize',
      'click .sg-controls-restore': 'restore',
      'click .sg-controls-expand-graphs': 'expandGraphs',

      // edit dropdown
      'click .edit_menu a': 'onModified',
      'click .sg-controls-trim-ends': 'crop',
      'click .sg-controls-delete-selection': 'removePoints',
      'click .sg-controls-flatten-elevation': 'flattenElevation',
      'click .sg-controls-exclude-from-metrics': 'excludeFromMetrics',
      'click .sg-controls-unexclude-from-metrics': 'unexcludeFromMetrics',
      'click .sg-controls-change-color': 'openChangeColor',
      'click .sg-controls-remove-control-points': 'removeControlPoints',
      'click .sg-controls-remove-metric': 'onRemoveMetricClick',

      // save as dropdown
      'click .sg-controls-save-route': 'saveRoute',
      'click .sg-controls-save-trip': 'saveTrip',
      'click .sg-controls-save-segment': 'saveSegment',
      'click .sg-controls-save-annotation': 'saveAnnotation',

      // persist ops
      'click .sg-persist-ops .save': 'save',
      'click .sg-persist-ops .revert': 'revert',

      // reference tools
      'click .sg-controls-reference-point': 'toggleReferencePoint',
      'click .sg-controls-reference-segment': 'referenceSegment',

      // planner mode
      'click .sg-controls-undo': 'undo',
      'click .sg-controls-redo': 'redo'
    },
    undo: function() {
      Routes.activeMap.undo();
    },
    redo: function() {
      Routes.activeMap.redo();
    },
    minimize: function() {
      Routes.activeMap.hideElevation();
      this.$el.addClass('collapsed');
    },
    restore: function() {
      Routes.activeMap.showElevation();
      this.$el.removeClass('collapsed');
    },
    expandGraphs: function() {
      this.graph.trigger('expand_graphs');
    },
    onSegmentSelect: function() {
      this.$('.sg-selection-tools').show();
      this.reposition()
      this.graph.resize()
    },
    toggleMetric: function(e) {
      var $li = $(e.target).closest('li');
      if($li.hasClass('disabled')) return;

      var $checkedBefore = $li.closest('ul').find('.active a');
      if ($li.hasClass('active')) {
        if ($checkedBefore.length === 1) {
          // don't let them de-select the last one!
          return;
        } else if (e.target.dataset.metric === 'ele'
          && JSON.stringify($checkedBefore.toArray().map(e => e.dataset.metric)) === JSON.stringify(['ele', 'surfaces'])) {
          // deselecting ele counts as deselecting the last one if the only other selected metric is surfaces
          return;
        }

        $li.removeClass('active');
        if (e.target.dataset.metric === 'ele') {
          // if we're deselecting ele, also deselect (and disable) surfaces
          const stLi = $checkedBefore.addBack().find('[data-metric="surfaces"]').closest('li');
          if (stLi.length > 0) {
            this.graph.showSurface(false);
            stLi.removeClass('active');
            stLi.addClass('disabled');
          }
        }
      } else {
        $li.addClass('active');
        if (e.target.dataset.metric === 'ele') {
          // if we're selecting ele, also re enable surfaces
          const stLi = $checkedBefore.addBack().find('[data-metric="surfaces"]').closest('li');
          if (stLi.length > 0) {
            stLi.removeClass('disabled');
          }
        }
      }

      var $checkedAfter = $li.closest('ul').find('.active a');
      var metrics = $checkedAfter.map(function() { return $(this).data('metric') });
      this.graph.metricsEnabled(metrics);
      if (e.target.dataset.metric === 'surfaces') {
        this.graph.toggleShowSurface();
      }
      this.graph.render();
    },
    zoomOut: function() {
      if(this.graph.zoomedIn())
        this.graph.zoomOutOnClick(null, false);
      else
        this.graph.recenterMap();
    },
    reCenter: function() {
      this.graph.segmentSelector.reCenter();
    },
    unload: function() {
      this.graph.segmentSelector.unload();
      this.graph.resize()
    },
    onSegmentDeselect: function() {
      this.$('.sg-selection-tools').hide();
      if(this.saveSelection) this.closeSaveForm();
      if(this.changeColor) this.closeColorChange();
    },
    reposition: function() {
      this.$el.width(this.graph.width());
      if(this.saveSelection) {
        this.saveSelection.reposition();
      }
    },

    onModified: function() {
      if(this.graph.options.segmentSelectorMode != 'planner') {
        this.$('.sg-persist-ops').show();
        this.reposition();
      }
    },
    saveSegment: function() {
      if(this.saveSelection) this.closeSaveForm();
      this.saveSelection = new SaveSelection({graph: this.graph});
      this.saveSelection.showSaveSegmentForm();
    },
    saveAnnotation: function() {
      if(this.saveSelection) this.closeSaveForm();
      this.saveSelection = new SaveSelection({graph: this.graph});
      this.saveSelection.showSaveAnnotationForm();
    },
    saveTrip: function() {
      if(this.saveSelection) this.closeSaveForm();
      this.saveSelection = new SaveSelection({graph: this.graph});
      this.saveSelection.showSaveTripForm();
    },
    saveRoute: function() {
      if(this.saveSelection) this.closeSaveForm();
      this.saveSelection = new SaveSelection({graph: this.graph});
      this.saveSelection.showSaveRouteForm();
    },
    save: function() {
      var route = Routes.activeMap.activeRoute.toSaveObj(),
          params = rwgps.csrfParams(),
          view = this,
          $saveButton = this.$('.sg-persist-ops .save');
      params._method = 'put';
      params[rwgps.config.assetType == "route" ? "route" : "trip"] = {
        track_points: JSON.stringify(route.track_points)
      };
      $.post(rwgps.config.assetPath, params, function() {
        $saveButton.html("Save");
        $saveButton.removeClass('disabled');
        view.$('.sg-persist-ops').hide();
        view.reposition();
        $.jGrowl("Successfully updated " + rwgps.config.assetType + "!");
      });
      $saveButton.addClass('disabled');
      $saveButton.html("<i class='icon-spinner icon-spin'></i> Saving...");
    },
    revert: function() {
      window.location.reload();
    },
    toggleReferencePoint: function() {
      if(this._referencePointEnabled) {
        this.disableReferencePoint();
      } else {
        this.enableReferencePoint();
      }
    },
    enableReferencePoint: function() {
      if(this.graph.segmentSelector) {
        var slice = this.graph.zoomedSlice();
        this.graph.segmentSelector.unload();
        this.enableReferencePoint();
        this.graph.zoomToDataSlice(slice);
        return;
      }
      this.$('.sg-controls-reference-point').closest('li').addClass('active');
      this.graph.bindTo(this.graph, 'pointselected', this.referencePoint);

      // standard zoom-on-drag allows zooming in to select point
      this._revertDragBehaviorToSelectSegment = this.graph.segmentselectedBehavior == 'select_segment';
      this.graph.setDragBehaviorToZoomIn();

      this._referencePointEnabled = true;
      this.graph.trigger('reference:point:mode_enabled');
    },
    disableReferencePoint: function() {
      this.$('.sg-controls-reference-point').closest('li').removeClass('active');
      this.graph.unbindFrom(this.graph, 'pointselected', this.referencePoint);
      if(this.graph.zoomedIn()) this.graph.zoomOut()
      if(this._revertDragBehaviorToSelectSegment) {
        delete this._revertDragBehaviorToSelectSegment;
        this.graph.setDragBehaviorToSelectSegment();
      }
      this._referencePointEnabled = false;
      this.graph.trigger('reference:point:mode_disabled');
    },
    referencePointEnabled: function() {
      return this._referencePointEnabled;
    },
    referencePoint: function(i) {
      this.disableReferencePoint();
      this.graph.trigger('reference:point', i);
    },
    referenceSegment: function() {
      this.graph.trigger('reference:segment', this.dataSlice());
    },
    dataSlice: function() {
      return this.graph.segmentSelector.dataSlice;
    },
    removePoints: function() {
      if(this.graph.options.segmentSelectorMode === 'planner') {
        // in the route planner, we've got multi-route editing, so cutting out the selected slice
        // and ending up with two routes is OK
        this.removeSlice();
        return;
      }

      var dataSlice = this.dataSlice();
      this.graph.segmentSelector.unload();
      var pt = dataSlice.firstPoint();
      var route = (pt.segment || pt.nextSegment).route;
      var map = route.map;
      var newRoute = route.removeSlice(dataSlice);
      var connectingSeg = route.lastSegment;
      if(newRoute) {
        map.removeRoute(newRoute);
        var offsetDist = connectingSeg.nextControlPoint.distance +
          connectingSeg.nextControlPoint.distanceFromPoint(newRoute.firstSegment.prevControlPoint) -
          newRoute.firstSegment.prevControlPoint.distance;
        _.each(newRoute.trackPoints(), function(pt) {
          pt.distance += offsetDist;
        });
        connectingSeg.nextControlPoint.setNextSegment(newRoute.firstSegment);
        connectingSeg.slurpNext();
      }
      route.rebuildBounds();
      route.redraw();
      route.calculateMetrics();
    },
    crop: function() {
      var dataSlice = this.dataSlice();
      this.unloadWithoutRecenter();
      var pt = dataSlice.firstPoint();
      (pt.segment || pt.nextSegment).route.cropTo(dataSlice);
      Routes.activeMap.activeRoute.redraw();
    },
    unloadWithoutRecenter: function() {
      var segmentSelector = this.graph.segmentSelector;
      Routes.activeMap.withRecenterDisabled(function() {
        segmentSelector.unload();
      });
    },
    flattenElevation: function() {
      var slice = this.dataSlice(),
          firstPt = slice.firstPoint(),
          lastPt = slice.lastPoint(),
          domain = this.graph.metricsCalculatorForDataToRender().hasDistance() ? "distance" : "time",
          domainOffset = firstPt[domain],
          mult = (lastPt.ele - firstPt.ele) / (lastPt[domain] - firstPt[domain]);
      _.each(this.dataSlice().points(), function(pt) {
        pt.ele = (pt[domain] - domainOffset) * mult + firstPt.ele;
      });
      this.graph.render();
      this.unloadWithoutRecenter();
    },
    changeSurfaceTo: function (surface) {
      const dataSlice = this.dataSlice();
      dataSlice.points().forEach(tp => {
        tp.surface = surface;
        tp.ghSurface = surface; // need to overwrite this so this modification isn't reverted on snapshot/reload
        tp.modified = true;
      })
      const route = Routes.activeMap.activeRoute;
      route.recalculatePolylines();
      Routes.activeMap.drawRouteDistanceMarkers();
      Routes.activeMap.drawCoursePointIcons(route.coursePoints());
      Routes.activeMap.snapshot();
      rwgps.Events.trigger('surfacesChanged')
      this.graph.render();
      this.unloadWithoutRecenter();
    },
    removeControlPoints: function() {
      var slice = this.dataSlice(),
          firstPt = slice.firstPoint(),
          lastPt = slice.lastPoint(),
          firstSeg = firstPt.segment || firstPt.nextSegment || firstPt.prevSegment,
          lastSeg = lastPt.segment || lastPt.prevSegment || lastPt.nextSegment

      // check to see if there's a cp in the slice, bail if there isn't
      if (firstSeg._segId === lastSeg._segId) {
        return
      }

      // walk segments, slurping next until we catch up to lastSeg or we reach the end
      while (firstSeg && lastSeg && firstSeg._segId !== lastSeg._segId && !!firstSeg.nextSegment) {
        firstSeg.slurpNext()
        firstSeg = firstPt.segment || firstPt.nextSegment || firstPt.prevSegment
        lastSeg = lastPt.segment || lastPt.prevSegment || lastPt.nextSegment
      }

      // add new controlpoints on either end of initial slice
      if (lastPt.segment) {
        var lastSegmentI = _.indexOf(lastSeg.trackPoints, lastPt);
        lastSeg.splitAfter(lastSegmentI - 1);
      }

      if (firstPt.segment) {
        var firstSegmentI = _.indexOf(firstSeg.trackPoints, firstPt);
        firstSeg.splitAfter(firstSegmentI - 1);
      }
      this.unloadWithoutRecenter();
    },
    excludeFromMetrics: function(reverseOperation) {
      const dataSlice = this.dataSlice()
      this.graph.segmentSelector.unload()
      const firstPoint = dataSlice.firstPoint()
      const lastPoint = dataSlice.lastPoint()
      ;[dataSlice.firstPoint(), dataSlice.lastPoint()].forEach(endPoint => {
        if (endPoint.segment) {
          endPoint.segment.splitAfter(endPoint.segment.trackPoints.indexOf(endPoint) - 1)
        }
      })
      const lastSegment = lastPoint.segment || lastPoint.prevSegment
      const route = lastSegment.route
      // if we split the segment, we need to advance before excluding.
      // if we did not split (the selection was on a control point), then exclude the firstSegment
      let segment = firstPoint.nextSegment
      do {
        segment.setExcludeFromMetrics(!(reverseOperation === true), true)
      } while((segment = segment.nextSegment) !== lastSegment.nextSegment && segment)
      route.redraw()
      route.calculateMetrics()
      Routes.activeMap.drawRouteDistanceMarkers()
      Routes.activeMap.snapshot();
    },
    unexcludeFromMetrics: function() {
      this.excludeFromMetrics(true)
    },
    openChangeColor: function() {
      this.changeColor = new ChangeColor({graph: this.graph});
      this.changeColor.showChangeColor();
    },
    changeColorTo: function(color) {
      const dataSlice = this.dataSlice()
      this.graph.segmentSelector.unload()
      const firstPoint = dataSlice.firstPoint()
      const lastPoint = dataSlice.lastPoint()
      ;[dataSlice.firstPoint(), dataSlice.lastPoint()].forEach(endPoint => {
        if (endPoint.segment) {
          endPoint.segment.splitAfter(endPoint.segment.trackPoints.indexOf(endPoint) - 1)
        }
      })
      const lastSegment = lastPoint.segment || lastPoint.prevSegment
      const route = lastSegment.route
      let segment = firstPoint.nextSegment
      do {
        segment.color = color
      } while((segment = segment.nextSegment) !== lastSegment.nextSegment && segment)
      route.redraw();
      Routes.activeMap.drawRouteDistanceMarkers();
      Routes.activeMap.drawCoursePointIcons(route.coursePoints());
      Routes.activeMap.snapshot();
    },
    onRemoveMetricClick: function(e) {
      this.removeMetric($(e.currentTarget).data('metric'));
    },
    removeMetric: function(metric) {
      _.each(this.dataSlice().points(), function(pt) {
        pt[metric] = undefined;
      });
      this.graph.render();
    },
    closeSaveForm: function() {
      this.saveSelection.$el.remove();
      delete this.saveSelection;
    },
    closeColorChange: function() {
      this.changeColor.$el.remove();
      delete this.changeColor;
    },
    removeSlice: function() {
      var dataSlice = this.dataSlice();
      this.unloadWithoutRecenter();
      var pt = dataSlice.firstPoint();
      (pt.segment || pt.nextSegment).route.removeSlice(dataSlice);
    }
  });

  SaveSelection = Backbone.View.extend({
    className: 'sg-segment-selector-save-form',
    tmplId: 'sg-tmpl-save-segment',
    initialize: function() {
      this.graph = this.options.graph;
      this.render();
      this.$el.prependTo('body');
    },
    events: {
      // initially visible actions
      'click .sg-cancel': 'close',

      // save segment
      'change .sg-save-segment select.matching_scope': 'onMatchingScopeChange',
      'keypress .sg-save-segment input.title': 'onEnterSaveSegment',
      'click .sg-save-segment .sg-save': 'saveSegment',

      // save annotation
      'keypress .sg-save-annotation input.comment': 'onEnterAnnotate',
      'click .sg-save-annotation .sg-annotate': 'annotate',

      // save trip
      'keypress .sg-save-trip input.name': 'onEnterSaveTrip',
      'click .sg-save-trip .sg-save': 'saveTrip',

      // save route
      'keypress .sg-save-route input.name': 'onEnterSaveRoute',
      'click .sg-save-route .sg-save': 'saveRoute'
    },
    onMatchingScopeChange: function() {
      var matchingScope = this.$('.matching_scope').val();
      this.$('.matching_scope_dep').hide(); // hide group/event options if visible
      if(rwgps.config.currentUser.account_level < 2 &&
         (matchingScope == 'user' || matchingScope == 'group' || matchingScope == 'event')) {
        // restricted to premium only!
        this.$('.matching_scope_restricted').show();
        setTimeout(function() {
          this.$('.matching_scope').val('public');
        }, 500);
      } else if(matchingScope == 'group') {
        this.$('.matching_scope_group').show();
      } else if(matchingScope == 'event') {
        this.$('.matching_scope_event').show();
      }
    },
    reposition: function() {
      var offset = this.graph.controlsBar.$('.sg-selection-tools a:first').offset(),
          left;

      left = offset.left - this.$el.width()/2;
      this.$el.offset({left: left, top: offset.top - this.$el.height() - 20});
    },
    render: function() {
      this.$el.html(SG.template(this.tmplId, {
        user: rwgps.config.currentUser,
        groups: rwgps.activeNs.adminGroups,
        events: rwgps.activeNs.adminEvents
      })).css({zIndex: this.graph.zIndex(), position: 'absolute'});
      return this;
    },
    showSaveSegmentForm: function() {
      this.$('.sg-save-segment').show();
      this.$('.title').focus();
      this.reposition();
    },
    showSaveAnnotationForm: function() {
      this.$('.sg-save-annotation').show();
      this.$('.comment').focus();
      this.reposition();
    },
    showSaveRouteForm: function() {
      this.$('.sg-save-route').show();
      this.$('.name').focus();
      this.reposition();
    },
    showSaveTripForm: function() {
      this.$('.sg-save-trip').show();
      this.$('.name').focus();
      this.reposition();
    },
    onEnterAnnotate: function(e) { if(e.keyCode==13) this.annotate(); },
    onEnterSaveSegment: function(e) { if(e.keyCode==13) this.saveSegment(); },
    onEnterSaveTrip: function(e) { if(e.keyCode==13) this.saveTrip(); },
    onEnterSaveRoute: function(e) { if(e.keyCode==13) this.saveRoute(); },
    close: function() {
      this.graph.controlsBar.closeSaveForm();
    },
    saveTrip: function() {
      var graph = this.graph,
          dataSlice = graph.controlsBar.dataSlice(),
          params = rwgps.csrfParams();
      params.i = dataSlice.i;
      params.count = dataSlice.count;
      params.name = this.$('.sg-save-trip .name').val();
      var privacyCode = new URLSearchParams(window.location.search).get('privacy_code');
      if(privacyCode) params.privacy_code = privacyCode;
      $.post('/trips/' + rwgps.config.assetId + '/new_from_slice.json', params, function(data) {
        $.jGrowl("New ride saved: <a href='/trips/" + data.id + "'>View ride</a>");
        graph.segmentSelector.unload();
      });
    },
    saveRoute: function() {
      var graph = this.graph,
          dataSlice = graph.controlsBar.dataSlice(),
          params = rwgps.csrfParams();
      params.i = dataSlice.i;
      params.count = dataSlice.count;
      params.assetType = rwgps.config.assetType;
      params.assetId = rwgps.config.assetId;
      params.name = this.$('.sg-save-route .name').val();
      var privacyCode = new URLSearchParams(window.location.search).get('privacy_code');
      if(privacyCode) params.privacy_code = privacyCode;
      $.post('/routes/new_from_slice.json', params, function(data) {
        $.jGrowl("New route created: <a href='/routes/" + data.id + "'>View route</a>");
        graph.segmentSelector.unload();
      });
    },
    saveSegment: function() {
      var graph = this.graph,
          dataSlice = graph.controlsBar.dataSlice(),
          title = this.$('input.title').val(),
          matchingScope = this.$('select.matching_scope').val();
      if(title.replace(/ /g,'') == '') {
        customAlert('Please enter a name for the segment before saving.');
        return;
      }

      var points = JSON.stringify(_.map(_.filter(dataSlice.data(),function(pt) { return pt.point; }), function(pt) { return pt.toMiniObj(); }));
      var segmentAttrs = {
        title: title,
        matching_scope: matchingScope,
        points: points,
        created_from_type: this.graph.options.segmentCreatedFromType,
        created_from_id: this.graph.options.segmentCreatedFromId
      };
      if(matchingScope == 'group') {
        segmentAttrs.group_id = this.$('.matching_scope_group select').val();
      } else if(matchingScope == 'event') {
        segmentAttrs.event_id = this.$('.matching_scope_event select').val();
      }
      $.post('/segments',
             {
               segment: segmentAttrs
             },
             function(data) {
               graph.trigger('segmentselector:create', data.segment);
               graph.segmentSelector.unload();
             });
    },
    annotate: function() {
      var graph = this.graph,
          dataSlice = graph.controlsBar.dataSlice(),
          comment = this.$('input.comment').val();
      if(comment.replace(/ /g,'') == '') {
        customAlert('Please enter an annotation, which is just a comment on the selected segment.');
        return;
      }
      var annotation = {
        first_i: dataSlice.i,
        count: dataSlice.count,
        comment: comment
      };
      $.post('/' + this.graph.options.segmentCreatedFromType + 's/' + this.graph.options.segmentCreatedFromId + '/annotate_segment.json',
             {
               segment: annotation
             },
             function() {
               graph.segmentSelector.unload();
             });
      this.graph.trigger('annotation:added', annotation);
    }
  });

  ChangeColor = Backbone.View.extend({
    className: 'sg-segment-selector-change-color',
    tmplId: 'sg-tmpl-change-color',
    initialize: function () {
      this.graph = this.options.graph;
      this.render();
      this.$el.prependTo('body');
    },
    events: {
      'click .sg-cancel': 'close'
    },
    render: function() {
      this.$el.html(SG.template(this.tmplId, {})).css({zIndex: this.graph.zIndex(), position: 'absolute'});
      return this;
    },
    changeColorTo: function(color) {
      this.graph.controlsBar.changeColorTo(color)
    },
    showChangeColor: function() {
      this.$('.color_picker').colorPicker({
        click: _.bind(function(color) {
          this.changeColorTo(parseInt('0x' + color.split("#")[1]));
        }, this),
        defaultColor: 999, // hack to force no default
        color: Routes.colors,
        columns: 7
        });
      this.reposition();
    },
    reposition: SaveSelection.prototype.reposition,
    close: function() {
      this.graph.controlsBar.closeColorChange();
    }
  });

})(SampleGraph, window);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.controls.js